import adserver from 'services/adserver';
import { basketsKeys } from './baskets.keys';
import { BasketParams } from './baskets.types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

const getBasketById = async (id: number): Promise<BasketParams> => {
  const { data } = await adserver({ url: `/basket/${id}`, headers: {} });
  return data;
};

export const useGetBasketById = <TData = BasketParams>(
  id: number,
  select?: (data: BasketParams) => TData,
): UseQueryResult<TData, unknown> => {
  const result = useQuery({
    queryKey: basketsKeys.detail(id),
    queryFn: () => getBasketById(id),
    enabled: !!id,
    select,
  });

  return result;
};
